import React from 'react'
import { MyProfilePersonalInfo } from '../../Component';
import { LanguageProvider } from '../../store'
import useScrollToTopWithDelay from '../../hooks/useScrollToTopWithDelay';

function PersonalInformation() {
  useScrollToTopWithDelay(500);
  return (
    <div>
      <LanguageProvider >
        <MyProfilePersonalInfo />  
     </LanguageProvider>


    </div>
  )
}

export default PersonalInformation;